<template lang="html">
  <div>
    <club-settings-item v-model="selectedItemId" />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :edit-action="editItem"
        :search="true"
        :search-value="lastSearch"
        :items="selectedItems"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        search-hint="Filter by setting name / value"
        :headers="headers"
        @search="setLastSearch"
      >
        <template slot="left-filters">
          <v-autocomplete
            v-model="groupLabel"
            :items="groupTypes"
            auto
            single-line
            hint="Filter by setting type"
            persistent-hint
            placeholder="Select Setting Type"
          />
        </template>
        <template
          slot="value"
          slot-scope="props"
        >
          <span>{{ getSettingDisplayValue(props.item) }}</span>
        </template>
      </item-select-table>
    </v-card>
  </div>
</template>

<script>
import itemSelect from '../../mixins/itemEditor/itemSelect'
import ClubSettingsItem from './ClubSettingsItem'
import clubSettingsCommon from './mixins/clubSettingsCommon'

export default {
  name: 'ClubSettingsList',
  components: {ClubSettingsItem},
  mixins: [itemSelect, clubSettingsCommon],
  data: function () {
    return {
      type: 'Club Setting',
      types: 'Club Settings',
      groupLabelVal: null,
      apiRecordCommand: 'clubSetting',
      pagination: undefined // Disable pagination for club settings
    }
  },
  computed: {
    groupLabel: {
      get () {
        var result = this.groupLabelVal
        if (result === null) result = localStorage.getItem('lastSettingGroupLabel')
        if (result === null || !this.groupTypes.find(gt => gt.value === result)) {
          result = 'Staff Minimums & Maximums' // TODO: Find a better default
        }
        return result
      },
      set (val) {
        this.groupLabelVal = val
        localStorage.setItem('lastSettingGroupLabel', val || '')
      }
    },
    lastSearch: {
      get () {
        var result = localStorage.getItem('lastSettingSearch')
        if (result === null) result = ''
        return result
      },
      set (val) {
        localStorage.setItem('lastSettingSearch', val || '')
      }
    },
    groupTypes () {
      return [{text: 'All Settings', value: ''}].concat(this.clubSettingDefaults.map(csd => ({text: csd.groupLabel, value: csd.groupLabel})))
    },
    selectedItems () {
      return this.items.filter(i => !this.groupLabel || this.groupLabel === i.groupLabel)
    },
    headers () {
      return [
        ...this.groupLabel ? [] : [this.headerText('Type', 'groupLabel')],
        this.headerText('Setting', 'label'),
        this.headerSlot('Value', 'value', false, 'ft-truncate-list-value')
      ]
    },
    isDeleteDisabled () {
      return true
    },
    useItemAuditHistory () {
      return !this.itemData.legacy
    }
  },
  methods: {
    stripHtml (html) {
      return new DOMParser().parseFromString(html, 'text/html').body.textContent || ''
    },
    setLastSearch (val) {
      this.lastSearch = val
    },
    getSettingDisplayValue (item) {
      const defaultSetting = this.getDefaultSetting(item.name)
      if (defaultSetting.options && defaultSetting.options.length) {
        const option = defaultSetting.options.find(s => s.value === item.value)
        return option ? option.name : item.value
      }
      if (defaultSetting.valueType === 'HTML') {
        return this.stripHtml(item.value)
      }
      return item.value
    },
    listResourceCommands () {
      return this.clubSettingDefaultsCommand()
    },
    listCommandFilter (command) {
      command.resultFilter = data => {
        // Convert club settings to map
        const clubSettingsMap = data.reduce((map, setting) => {
          map[setting.name] = setting
          return map
        }, {})
        // Convert default settings to club settings
        for (let settingDefault of this.clubSettingDefaults) {
          let clubSetting = clubSettingsMap[settingDefault.name]
          if (clubSetting) {
            // There's a club setting for this.  use its value.
            settingDefault.value = clubSetting.value !== undefined ? clubSetting.value : settingDefault.value
            settingDefault.isDefault = false
          } else {
            // No club setting for this
            settingDefault.isDefault = true
          }
          settingDefault.id = settingDefault.name // We'll use the name for loading items
        }
        // Return default settings updated with club settings values instead of club settings
        return this.clubSettingDefaults
      }
      this.addCommandParamArrayVal(command, 'include_fields', 'legacy') // Include legacy settings from club5
      this.addCommandParamObjectVal(command, 'filter_methods', 'filterHiddenSettings', [true])
      // this.addCommandParamArrayVal(command, 'include_fields', 'valueTruncate') // Get a short version of the value
      // this.addCommandParamArrayVal(command, 'exclude_fields', 'value') // Don't return the full value

      return command
    }
  }
}
</script>
<style>
  td.ft-truncate-list-value span {
    max-width: 600px;
    text-overflow: ellipsis;
    display: block;
    white-space: nowrap;
    overflow: hidden;
  }
  @media only screen and (max-width: 1400px) {
    td.ft-truncate-list-value span {
      max-width: 400px;
    }
  }
  @media only screen and (max-width: 1200px) {
    td.ft-truncate-list-value span {
      max-width: 300px;
    }
  }
  @media only screen and (max-width: 800px) {
    td.ft-truncate-list-value span {
      max-width: 200px;
    }
  }
  @media only screen and (max-width: 600px) {
    td.ft-truncate-list-value span {
      max-width: 150px;
    }
  }

</style>
